/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
import { getDavPath } from '../utils/fileUtils.js'

/**
 * @param {object} fileInfo a FileInfo object
 * @param {string} mime the file mime type
 * @param {object} component the component to render
 */
export default function(fileInfo, mime, component) {
	const data = {
		mime,
		modal: component,
		failed: false,
		loaded: false,
		davPath: getDavPath(fileInfo),
		source: fileInfo.source ?? getDavPath(fileInfo),
	}

	return Object.assign({}, fileInfo, data)
}
